module.exports = __webpack_public_path__ + "img/classBegins.fdb485b6.svg";